export default __webpack_public_path__ + "static/media/trashWhite.cbe7d17c.svg";